import { useEffect } from "react";

const EnterKeyClickHandler = () => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Enter") {
                const activeElement = document.activeElement as HTMLElement | null;

                if (activeElement) {
                    const hasTabIndex = activeElement.hasAttribute("tabindex");
                    const isDisabled =
                        (activeElement as HTMLInputElement).disabled ||
                        activeElement.getAttribute("aria-disabled") === "true";

                    if (
                        hasTabIndex &&
                        !isDisabled &&
                        typeof activeElement.click === "function"
                    ) {
                        activeElement.click(); // Simulate mouse click
                        e.preventDefault(); // Prevent default Enter behavior
                    }
                }

                e.preventDefault();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return null; // This component doesn't render anything
};

export default EnterKeyClickHandler;
